import { faArrowDownUpAcrossLine, faFileInvoiceDollar, faFileCircleCheck } from '@fortawesome/free-solid-svg-icons';

export const tabs = [
    { 
        id: 1, 
        src: 'https://app.powerbi.com/reportEmbed?reportId=91f076b0-011e-41f5-bbc4-8872941d9e4e&autoAuth=true&ctid=a72dda32-ee80-4da8-a3ac-ec0e9e41a50a', 
        tooltipId: "sales-in-out-stock-tooltip", 
        icon: faArrowDownUpAcrossLine ,
        page: 'sales'
    },
    { 
        id: 2, 
        src: 'https://app.powerbi.com/reportEmbed?reportId=54bf4b7a-2e72-4919-9cb4-70882f61d3d8&autoAuth=true&ctid=a72dda32-ee80-4da8-a3ac-ec0e9e41a50a', 
        tooltipId: "sales-in-out-stock-budget-tooltip", 
        icon: faFileInvoiceDollar,
        page: 'sales'
    },
    {
        id: 3,
        src: 'https://app.powerbi.com/reportEmbed?reportId=de412b30-3840-41cc-b9e9-6d79fe271285&autoAuth=true&ctid=a72dda32-ee80-4da8-a3ac-ec0e9e41a50a',
        tooltipId: 'protocol-tooltip',
        icon: faFileCircleCheck,
        page: 'protocol'
    },
  ];